import { Button } from "@mui/material";

import { GridItem, GridRow } from "commons/ui/Grid";

import CatalogForm from "components/form/CatalogForm";

import useCatalogForm from "hooks/form/useCatalogForm";

function NuovoCatalogo() {
    const formCatalogHook = useCatalogForm();

    const { buttonSave } = formCatalogHook;

    return (
        <>
            <GridRow className={"title-top-paper"}>
                <GridItem>
                    <h1>Aggiungi Catalogo</h1>
                </GridItem>
            </GridRow>

            <CatalogForm formCatalogHook={formCatalogHook} />

            <GridRow justifyContent={"right"}>
                <GridItem className={"button-under-paper"}>
                    <Button variant={"contained"} onClick={buttonSave}>
                        Salva
                    </Button>
                </GridItem>
            </GridRow>
        </>
    );
}

export default NuovoCatalogo;
